import Konsole from "./konsole/Konsole";
const CustomerServiceCharge = (price: number, store: any) => {
  // Konsole.log('storestoreasdf',store)
  // return store?.domain_setting?.is_customer == 1
  //   ? (price * parseFloat(store?.domain_setting?.service_charge)) / 100 < parseFloat(store?.domain_setting?.min_service_charge)
  //   ? store?.domain_setting?.min_service_charge
  //   : (Number(price) * parseFloat(store?.domain_setting?.service_charge)) / 100 > parseFloat(store?.domain_setting?.max_service_charge)
  //   ? store?.domain_setting?.max_service_charge
  //   : (price * parseFloat(store?.domain_setting?.service_charge)) / 100
  //   : 0;

  const store_domain_setting = store?.domain_setting;
  if (store_domain_setting?.is_customer != 1) {
    return 0
  }

  let servCharge = 0;
  console.log("_store_domain_setting", store_domain_setting)
  let min_service_charge = (store_domain_setting?.min_service_charge);
  let max_service_charge = (store_domain_setting?.max_service_charge);
  let service_charge = (price * parseFloat(store_domain_setting?.service_charge)) / 100;
  if (min_service_charge == 0 && max_service_charge == 0) {
    servCharge = service_charge
  } else if (min_service_charge == 0 && max_service_charge > 0) {
    servCharge = service_charge > max_service_charge ? max_service_charge : service_charge
  } else if (min_service_charge > 0 && max_service_charge == 0) {
    servCharge = service_charge < min_service_charge ? min_service_charge : service_charge
  }

  return servCharge;

};

export default CustomerServiceCharge;
